import { Button, Stack } from "@mui/material";
import React from "react";
import Introduction101 from "../IntroSection/Introduction101";
import Footer101 from "../Footer101";

const MainSecion3Backup = () => {
  return (
    <>
      <Stack
        sx={{
          // backgroundColor: "#f4f6fa",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          // marginTop: "120px",
          width: { xs: "100%", sm: "100%" },
          // background: "linear-gradient(to right, #cce7ff, #f4e3ff)", //
          // backgroundColor: "white",
          fontFamily: "'Lato', sans-serif",
          // border: "1px solid blue",
        }}
      >
        <Introduction101
          text="Easy solutions on WhatsApp"
          text4="Easy solutions on WhatsApp"
          text2="Simplify your customer journey with WhatsApp. From ads to templates, forms to payments-manage everything in one chat. Offer faster interactions, reduce drop-offs and improve conversions with a smooth and connected experience."
          text3="Manage ads, forms, payments and tracking on WhatsApp, offering a seamless chat experience that drives faster interactions and higher conversions."
        />
      </Stack>
    </>
  );
};

export default MainSecion3Backup;
